// src/Reports.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getStorage } from '../Components/Storage.js';
import '../CSS/Umbrella.css';
import UmbrellaReportsGrid from './UmbrellaReportsGrid.js';
import useIsMobile from '../Components/UseIsMobile.js';

const YourComponent = () => {
  const { companyName } = useParams();
  const [clients, setClients] = useState([]);
  const [cansee, setCanSee] = useState(false);

  const username = getStorage('username');
  const isMobile = useIsMobile();

  // Filter controls
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSector, setSelectedSector] = useState('');
  const [groupResponsible, setGroupResponsible] = useState('');
  const [targetedEntity, setTargetedEntity] = useState('');
  const [selectedDropdownFilter, setSelectedDropdownFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedIndustryFilter, setSelectedIndustryFilter] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');

  useEffect(() => {
    fetch('/api/hello')
      .then(r => r.json())
      .then(data => setClients(data.clients || []))
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (!username || clients.length === 0) return;
    const match = clients.find(c => 
      c.fields.Email?.toLowerCase() === username.toLowerCase() &&
      c.fields.SpecCompany &&
      c.fields.Company === companyName
    );
    setCanSee(!!match);
  }, [clients, username, companyName]);

  // If they cannot see, show only this:
  if (!cansee) {
    return (
      <div className="umbrella">
        <p>You don't have access to view this content.</p>
      </div>
    );
  }

  // Handlers (omitted for brevity, unchanged)...
  const handleSearch = e => setSearchTerm(e.target.value);
  const handleSectorChange = e => {
    const v = e.target.value;
    setSelectedSector(v === selectedSector ? '' : v);
  };
  const handleGroupResponsibleChange = e => setGroupResponsible(e.target.value);
  const handleTargetedEntityChange = e => setTargetedEntity(e.target.value);
  const handleRegionChange = e => {
    const v = e.target.value;
    setSelectedRegion(v === selectedRegion ? '' : v);
  };
  const handleClear = () => {
    setSearchTerm('');
    setSelectedSector('');
    setGroupResponsible('');
    setTargetedEntity('');
    setSelectedDropdownFilter('');
    setStartDate('');
    setEndDate('');
    setSelectedIndustryFilter('');
    setSelectedRegion('');
  };
  const applyDropdownFilter = e => setSelectedDropdownFilter(e.target.value);
  const applyIndustryFilter = e => setSelectedIndustryFilter(e.target.value);
  const handleStartDateChange = e => setStartDate(e.target.value);
  const handleEndDateChange = e => setEndDate(e.target.value);

  return (
    <div className="umbrella">
      <h2>Reports for {companyName}</h2>

      {!isMobile && (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '20vh', // This sets the height to the full viewport height
        marginTop: '10vh',
        marginBottom: '14vh'
      }}>
      {/* Search and Sector filter */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          
    
          {/* Sector filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <h3>Sector Filter:</h3>
            {/* ... Radio buttons for sectors */}
            <label style={{ color: selectedSector !== 'Animal Rights' ? 'white' : '#cab069' }}>
                <input
                  type="radio"
                  value="Animal Rights"
                  checked={selectedSector === 'Animal Rights'}
                  onChange={handleSectorChange}
                />
                <span>Animal Rights</span>
              </label>
              <label style={{ color: selectedSector !== 'Energy Sector' ? 'white' : '#cab069' }}>
                <input
                  type="radio"
                  value="Energy Sector"
                  checked={selectedSector === 'Energy Sector'}
                  onChange={handleSectorChange}
                />
                <span>Energy Sector</span>
              </label>
              <label style={{ color: selectedSector !== 'Pharmaceuticals' ? 'white' : '#cab069' }}>
                <input
                  type="radio"
                  value="Pharmaceuticals"
                  checked={selectedSector === 'Pharmaceuticals'}
                  onChange={handleSectorChange}
                />
                <span>Pharma</span>
              </label>
              <label style={{ color: selectedSector !== 'Critical Insights' ? 'white' : '#cab069' }}>
                <input
                  type="radio"
                  value="Critical Insights"
                  checked={selectedSector === 'Critical Insights'}
                  onChange={handleSectorChange}
                />
                <span>Critical Insights</span>
              </label>
          </div>
        </div>
    
        {/* Clear button */}
        <button onClick={handleClear} className="clear-button">Clear</button>
      </div>

      {/* Region Filter */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <h3>Region Filter:</h3>
              {[
                'North America',
                'Latin America',
                'Western Europe',
                'Eastern Europe',
                'Middle East',
                'Asia',
                'Africa',
                'Oceania',
              ].map((region) => (
                <label
                  key={region}
                  style={{ color: selectedRegion !== region ? 'white' : '#cab069' }}
                >
                  <input
                    type="radio"
                    value={region}
                    checked={selectedRegion === region}
                    onChange={handleRegionChange}
                  />
                  <span className="region-text"> {region}</span>
                </label>
              ))}
            </div>
            
    {/* Advanced search row 1 */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
    <label>Search:&nbsp;
          <input
            type="text"
            placeholder="Search by Title"
            value={searchTerm}
            onChange={handleSearch}
          />
          </label>
        {/* Group Responsible search */}
        <label>
          Group Responsible:&nbsp;
          <input
            type="text"
            placeholder="Search by group"
            value={groupResponsible}
            onChange={handleGroupResponsibleChange}
          />
        </label>
    
        {/* Targeted Entity search */}
        <label>
          Targeted Entity:&nbsp;
          <input
            type="text"
            placeholder="Search by targeted entity"
            value={targetedEntity}
            onChange={handleTargetedEntityChange}
          />
        </label>
    
        {/* Type of Report dropdown */}
        <label htmlFor="dropdownFilter">Type of Report:</label>
        <select id="dropdownFilter" value={selectedDropdownFilter} onChange={applyDropdownFilter}>
          <option value="">Select an option</option>
          <option value="protest after-action">Protest After-Action</option>
          <option value="direct action">Direct Action</option>
          <option value="general intel">General Intel</option>
          <option value="infiltration">Infiltration</option>
        </select>
      </div>
    
      {/* Advanced search row 2 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '1rem'}}>
            {/* Targeted Industry dropdown */}
            <label htmlFor="industryFilter">Targeted Industry:</label>
            <select id="industryFilter" value={selectedIndustryFilter} onChange={applyIndustryFilter}>
                <option value="">Select an option</option>
                <option value="Fur and Leather">Fur and Leather</option>
                <option value="Hunting">Hunting</option>
                <option value="Research – CRO">Research – CRO</option>
                <option value="Research – Academic">Research – Academic</option>
                <option value="Research – Breeder">Research – Breeder</option>
                <option value="Research – General">Research – General</option>
                <option value="Research – Pharmaceuticals">Research – Pharmaceuticals</option>
                <option value="Research – Transportation">Research – Transportation</option>
                <option value="Research – Government">Research – Government</option>
                <option value="Research – Cosmetics">Research – Cosmetics</option>
                <option value="Research – Other">Research – Other</option>
                <option value="Agriculture – General">Agriculture – General</option>
                <option value="Agriculture – Transportation">Agriculture – Transportation</option>
                <option value="Agriculture – Government">Agriculture – Government</option>
                <option value="Agriculture – Food Services">Agriculture – Food Services</option>
                <option value="Agriculture – Farms">Agriculture – Farms</option>
                <option value="Agriculture – Processing">Agriculture – Processing</option>
                <option value="Entertainment – Government">Entertainment – Government</option>
                <option value="Entertainment – Sports">Entertainment – Sports</option>
                <option value="Entertainment – Zoo/Park">Entertainment – Zoo/Park</option>
                <option value="Pet Industry">Pet Industry</option>
                <option value="Coal">ES - Coal</option>
                <option value="Logging">ES - Logging</option>
                <option value="Academic">ES - Academic</option>
                <option value="Financing">ES - Financing</option>
                <option value="Government">ES - Government</option>
                <option value="Fossil Fuels">ES - Fossil Fuels</option>
                <option value="Nuclear">ES - Nuclear</option>
                <option value="Renewables">ES - Renewables</option>
                <option value="Anti-Vaccine">Pharma - Anti-Vaccine</option>
                <option value="Access to Medicine">Pharma - Access to Medicine</option>
                <option value="GMO">Pharma - GMO</option>
                {/* Add more options as needed */}
              </select>
    
        {/* Start Date filter */}
        <label>
          Start Date:&nbsp;
          <input
            type="date"
            value={startDate}
            onChange={handleStartDateChange}
            style={{
              height: '30px',
              padding: '0 10px',
              fontSize: '16px',
              lineHeight: '1.5',
              boxSizing: 'border-box',
            }}
          />
        </label>
    
        {/* End Date filter */}
        <label>
          End Date:&nbsp;
          <input
            type="date"
            value={endDate}
            onChange={handleEndDateChange}
            style={{
              height: '30px',
              padding: '0 10px',
              fontSize: '16px',
              lineHeight: '1.5',
              boxSizing: 'border-box',
            }}
          />
        </label>
    
      </div>
    </div>
  )}

{isMobile && (
  <div className="mobile-filters">
    
    {/* 🔹 Sector Filter */}
    <details className="filter-section">
      <summary className="filter-header">Sector Filter</summary>
      <div className="filter-content">
        {['Animal Rights', 'Energy Sector', 'Pharmaceuticals', 'Critical Insights'].map((sector) => (
          <label key={sector}>
            <input type="radio" value={sector} checked={selectedSector === sector} onChange={(e) => setSelectedSector(e.target.value)} />
            {sector}
          </label>
        ))}
      </div>
    </details>

    {/* 🔹 Region Filter */}
    <details className="filter-section">
      <summary className="filter-header">Region Filter</summary>
      <div className="filter-content">
        {['North America', 'Latin America', 'Western Europe', 'Eastern Europe', 'Middle East', 'Asia', 'Africa', 'Oceania'].map((region) => (
          <label key={region}>
            <input type="radio" value={region} checked={selectedRegion === region} onChange={(e) => setSelectedRegion(e.target.value)} />
            {region}
          </label>
        ))}
      </div>
    </details>

    {/* 🔹 Advanced Search */}
    <details className="filter-section advanced-search">
      <summary className="filter-header">Advanced Search</summary>
      <div className="filter-content">
        <label>Search:
          <input type="text" placeholder="Search by Title" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </label>
        <label>Group Responsible:
          <input type="text" placeholder="Search by group" value={groupResponsible} onChange={(e) => setGroupResponsible(e.target.value)} />
        </label>
        <label>Targeted Entity:
          <input type="text" placeholder="Search by targeted entity" value={targetedEntity} onChange={(e) => setTargetedEntity(e.target.value)} />
        </label>
        <label>Targeted Industry:
          <select value={selectedIndustryFilter} onChange={(e) => setSelectedIndustryFilter(e.target.value)}>
            <option value="">Select an option</option>
            <option value="Fur and Leather">Fur and Leather</option>
            <option value="Hunting">Hunting</option>
            <option value="Research – CRO">Research – CRO</option>
            <option value="Research – Academic">Research – Academic</option>
            <option value="Research – Breeder">Research – Breeder</option>
            <option value="Research – General">Research – General</option>
            <option value="Research – Pharmaceuticals">Research – Pharmaceuticals</option>
            <option value="Research – Transportation">Research – Transportation</option>
            <option value="Research – Government">Research – Government</option>
            <option value="Research – Cosmetics">Research – Cosmetics</option>
            <option value="Research – Other">Research – Other</option>
            <option value="Agriculture – General">Agriculture – General</option>
            <option value="Agriculture – Transportation">Agriculture – Transportation</option>
            <option value="Agriculture – Government">Agriculture – Government</option>
            <option value="Agriculture – Food Services">Agriculture – Food Services</option>
            <option value="Agriculture – Farms">Agriculture – Farms</option>
            <option value="Agriculture – Processing">Agriculture – Processing</option>
            <option value="Entertainment – Government">Entertainment – Government</option>
            <option value="Entertainment – Sports">Entertainment – Sports</option>
            <option value="Entertainment – Zoo/Park">Entertainment – Zoo/Park</option>
            <option value="Pet Industry">Pet Industry</option>
            <option value="Coal">ES - Coal</option>
            <option value="Logging">ES - Logging</option>
            <option value="Academic">ES - Academic</option>
            <option value="Financing">ES - Financing</option>
            <option value="Government">ES - Government</option>
            <option value="Fossil Fuels">ES - Fossil Fuels</option>
            <option value="Nuclear">ES - Nuclear</option>
            <option value="Renewables">ES - Renewables</option>
            <option value="Anti-Vaccine">Pharma - Anti-Vaccine</option>
            <option value="Access to Medicine">Pharma - Access to Medicine</option>
            <option value="GMO">Pharma - GMO</option>
          </select>
        </label>
        <label>Start Date:
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>
        <label>End Date:
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>
      </div>
    </details>

    {/* 🔹 Clear Button */}
    <button onClick={handleClear} className="clear-button">Clear</button>
  </div>
)}

      {/* The grid always renders once cansee is true */}
      <UmbrellaReportsGrid
        searchTerm={searchTerm}
        selectedSector={selectedSector}
        groupResponsible={groupResponsible}
        targetedEntity={targetedEntity}
        selectedDropdownFilter={selectedDropdownFilter}
        compName={companyName}
        startDate={startDate}
        endDate={endDate}
        selectedIndustryFilter={selectedIndustryFilter}
        selectedRegion={selectedRegion}
      />
    </div>
  );
};

export default YourComponent;
